<template>
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <ul role="list" class="mx-auto mt-20 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        <li v-for="sponsor in sponsoren" :key="sponsor.name">
          <a :href="sponsor.website" target="_blank">
            <img v-if="sponsor.imageUrl" class="aspect-[3/2] w-6/12 rounded-l object-center m-auto" :src="sponsor.imageUrl" :alt="sponsor.name" />
            <h3 class="mt-6 text-lg font-semibold leading-8 tracking-tight text-gray-900">{{ sponsor.name }}</h3>
          </a>
          <ul role="list" class="mt-6 flex gap-x-6">
          </ul>
        </li>
      </ul>
    </div>
</template>
<script>
export default {
  name: 'GridComponent',
  props: {
    msg: String
  },
  data() {
    return {
      sponsoren: [
        // {
        //   name: 'Spacescooter',
        //   website: 'https://www.spacescooter.eu/',
        //   imageUrl: 'https://cdn.shopify.com/s/files/1/1330/4091/files/logo_2_400x100_410x.png?v=1614294663'
        // },
        // {
        //   name: 'Bij Mies',
        //   website: 'https://www.bijmies.nl/',
        //   imageUrl: 'https://www.bijmies.nl/wp-content/uploads/2022/02/Bij-Mies_logo.png'
        // },
        // {
        //   name: 'Bijzonder design store',
        //   website: 'https://www.bijzonderdesignstore.nl/',
        //   imageUrl: 'https://cdn.webshopapp.com/shops/253187/themes/139166/assets/logo.png?20201228123625'
        // },
        // {
        //   name: 'Boekeldruk',
        //   website: 'https://www.boekeldruk.nl/',
        //   imageUrl: 'img/boekeldruk.jpg'
        // },
        {
          name: 'Algonkin',
          website: 'http://www.algonkin.nl/',
          imageUrl: 'img/algonkin.jpg'
        },
        {
          name: 'Slimpie',
          website: 'https://www.slimpie.com/',
          imageUrl: 'https://www.slimpie.com/build/images/logo-slimpie.0679926c.svg'
        },
        {
          name: 'Farmfrites',
          website: 'https://www.farmfrites.com/nl-nl/',
          imageUrl: 'https://www.farmfrites.com/dist/images/Logo.png'
        },
        // {
        //   name: 'Coop Venhorst',
        //   website: 'https://www.coop.nl/supermarkt/venhorst-kanters/3681?gclid=Cj0KCQjwxYOiBhC9ARIsANiEIfY0Q5HgzVRpVHduJpQv-cl1V0W6qfDyE5DHx_Ua-At7B_Aj9mrghY0aAqNUEALw_wcB&gclsrc=aw.ds',
        //   imageUrl: 'img/coop.png'
        // },
        // {
        //   name: 'Bakker van de Ven',
        //   website: 'https://bakkervandeven.nl/',
        //   imageUrl: 'img/bakkervandeven.jpg'
        // },
        // {
        //   name: 'Mikkis',
        //   website: 'https://www.mikkis.nl/',
        //   imageUrl: 'https://primary.jwwb.nl/public/t/l/p/temp-svrjucecuauqghcyuzfg/3j4grh/6d1fa590-dc20-4bab-86a2-a578caa453f9.png'
        // },
        // {
        //   name: 'Kristallen & Zo',
        //   website: 'https://kristallenenzo.nl/',
        //   imageUrl: 'https://kristallenenzo.nl/wp-content/uploads/2019/09/KZ-Logo_RGBkopie-3.png'
        // },
        // {
        //   name: 'D\'n Houten Tol',
        //   website: 'https://dnhoutentol.nl/',
        //   imageUrl: 'https://dnhoutentol.nl/wp-content/uploads/2020/03/cropped-Transparant-1-e1585044882240-1.png'
        // },
        // {
        //   name: 'Het Sieraad',
        //   website: 'https://www.hetsieraadonline.nl/',
        //   imageUrl: 'https://www.hetsieraadonline.nl/templates/bychanelle-2015-front/images/het-sieraad-webshop.png'
        // },
        // {
        //   name: 'Nootkracht',
        //   website: 'https://www.nootkracht.nl/',
        //   imageUrl: 'https://primary.jwwb.nl/public/z/e/b/temp-bhpzfmoyoawpoleycumm/qoyqu6/nootkracht_logo_bruincontourovaal-1.webp'
        // },
        // {
        //   name: 'Coppens Warenhuis',
        //   website: 'https://www.coppenswarenhuis.nl/',
        //   imageUrl: 'img/coppens.png'
        // },
        // {
        //   name: 'NC Tuinservice',
        //   website: '',
        //   imageUrl: 'img/nc_tuinservice.jpg'
        // },
        // {
        //   name: 'Peelpop',
        //   website: 'https://www.peelpop.nl/',
        //   imageUrl: 'img/peelpop.jpg'
        // },
        // {
        //   name: 'Kinderopvang Elsendorp',
        //   website: 'https://www.kinderopvang-elsendorp.nl/',
        //   imageUrl: 'img/kinderopvang_elsendorp.jpg'
        // },
        // {
        //   name: 'Van Geloven',
        //   website: 'https://www.vangeloven.com/',
        //   imageUrl: 'img/vangeloven.svg'
        // },
        // {
        //   name: 'Krullen en Spullen',
        //   website: 'https://www.krullenenspullen.nl/',
        //   imageUrl: 'img/krullenenspullen.png'
        // },
        // {
        //   name: 'Strik Elektrotechniek',
        //   website: 'https://strik-elektrotechniek.nl/',
        //   imageUrl: 'img/strik_elektrotechniek.png'
        // },
        // {
        //   name: 'Tielemans Groentekwekerij',
        //   website: 'https://www.groentekwekerij.nl/',
        //   imageUrl: 'img/tielemans.svg'
        // },
        // {
        //   name: 'Haegens kraanverhuur',
        //   website: 'https://haegenskraanverhuur.nl/',
        //   imageUrl: 'img/haegens.png'
        // },
        // {
        //   name: 'Blizz',
        //   website: 'https://www.blizzboekel.nl/',
        //   imageUrl: 'img/blizz.jpg'
        // },
        // {
        //   name: 'White Rose Brocante',
        //   website: 'https://www.whiterosebrocante.nl/',
        //   imageUrl: 'img/whiterosebrocante.jpg'
        // },
        // {
        //   name: 'Salon Leff',
        //   website: 'http://www.salonleff.nl/',
        //   imageUrl: 'img/leff.png'
        // },
        // {
        //   name: 'Gerry v. Exel Keurslager',
        //   website: 'https://vanexel.keurslager.nl/',
        //   imageUrl: 'img/gerryvanexel.svg'
        // },
        {
          name: 'van Kaathoven',
          website: 'https://www.vankaathovengroep.nl/',
          imageUrl: 'img/vankaathoven.svg'
        },
        {
          name: 'Arts evenementen',
          website: 'https://www.artsevenementen.nl/',
          imageUrl: 'https://www.artsevenementen.nl/Media/Default/Logo/ArtsEvenementen_2kleur.png'
        },
        // {
        //   name: 'Electroworld Wim v.d. Broek',
        //   website: 'https://www.electroworld.nl/',
        //   imageUrl: 'img/electroworld.svg'
        // },
        // {
        //   name: 'Jos Janssen Timmerwerken',
        //   website: 'https://www.goudengids.nl/nl/bedrijf/Boekel/L120604318/Jos+Janssen+Timmerwerken+%26+Renovatie/',
        //   imageUrl: null
        // },
        // {
        //   name: 'Hema Boekel',
        //   website: 'https://winkels.hema.nl/nl/boekel/hema-boekel',
        //   imageUrl: 'https://dynl.mktgcdn.com/p/OdeVm5o6yvX5MMZOgjq63ZkZ7F2l_61CsSTJLyRWmWw/70x70.png'
        // },
        // {
        //   name: 'Beautysalon All in One',
        //   website: 'https://beautysalonallinone.nl/',
        //   imageUrl: 'img/beautysalonallinone.png'
        // },
        // {
        //   name: 'Gemakswinkel Ton Kanters',
        //   website: 'https://tonkanters.nl/',
        //   imageUrl: 'img/tonkanters.jpg'
        // },
        // {
        //   name: 'Bakkerij Merks',
        //   website: 'https://bakkerijmerks.nl/',
        //   imageUrl: 'https://bakkerijmerks.nl/wp-content/uploads/2018/04/logo.png'
        // },
        // {
        //   name: 'Marco van Delst Installatietechniek',
        //   website: 'https://www.vandelst.nl/',
        //   imageUrl: 'https://www.vandelst.nl/wp-content/uploads/2016/03/Logo-van-Delst-Installatietechniek-Boekel.jpg'
        // },
        // {
        //   name: 'De Griek Boekel',
        //   website: 'https://degriek-boekel.nl/',
        //   imageUrl: 'https://degriek-boekel.nl/wp-content/themes/yootheme/cache/0d/Logo-De-Griek-Boekel-0df0cee1.webp'
        // },
        // {
        //   name: 'JP Jansen Groenten en Fruit',
        //   website: 'https://www.facebook.com/p/JP-Jansen-Groente-en-Fruit-100071156394676/',
        //   imageUrl: 'img/jpjansen.jpg'
        // },
        // {
        //   name: 'Regiobank Boekel',
        //   website: 'https://www.regiobank.nl/uw-adviseur/wolters-advies-in-boekel.html?s_kwcid=AL!6157!3!603413229316!e!!g!!regiobank%20boekel&gclid=CjwKCAjwg-GjBhBnEiwAMUvNW_W1C_58ZnHGYZL0JAl_8sqs4WHTlxv1epo-eYmUuO4gkMrouPTgnhoCFooQAvD_BwE',
        //   imageUrl: 'img/regiobank.png'
        // },
        // {
        //   name: 'Plus boekel',
        //   website: 'https://www.plus.nl/supermarkten/boekel_plus-boekel_962?gclid=CjwKCAjwg-GjBhBnEiwAMUvNW3zODdOXobXbWExn-aKU9R134rnRMajCGpFJ4C4OfKrSsLW2cadZNhoCvXQQAvD_BwE',
        //   imageUrl: 'img/plus.png'
        // },
        // {
        //   name: 'Medical Event Service',
        //   website: 'https://medicaleventservice.nl/',
        //   imageUrl: 'img/medicaleventservice.png'
        // },
        // {
        //   name: 'D\'n Hijzelaar',
        //   website: 'http://www.denhijzelaar.nl/',
        //   imageUrl: 'img/hijzelaar.jpg'
        // },
        // {
        //   name: 'E&R Service',
        //   website: 'https://www.google.com/search?q=e%26r+service+boekel&rlz=1C1VDKB_nlNL991NL991&oq=E%26R&aqs=chrome.0.69i59j69i57.1710j0j7&sourceid=chrome&ie=UTF-8',
        //   imageUrl: 'img/erservice.png'
        // },
        // {
        //   name: 'Schonenberg',
        //   website: 'https://www.schonenbergplant.nl/',
        //   imageUrl: 'https://www.schonenbergplant.nl/wp-content/themes/schonenberg/assets/img/logo2.svg'
        // },
        // {
        //   name: 'BJC Tools',
        //   website: 'https://bjctools.nl/',
        //   imageUrl: 'img/bjctools.png'
        // },
        ],
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
